import { schemas } from '~interface/zod-schema'

export const DEFAULT_FILE_TYPE_WHITELIST = [
  '.bmp',
  '.csv',
  '.doc',
  '.docx',
  '.gif',
  '.gz',
  '.heic',
  '.heif',
  '.ico',
  '.jpeg',
  '.jpg',
  '.json',
  '.key',
  '.log',
  '.md',
  '.numbers',
  '.odt',
  '.ods',
  '.pages',
  '.pdf',
  '.png',
  '.ppt',
  '.pptx',
  '.rtf',
  '.tar',
  '.tif',
  '.tiff',
  '.tsv',
  '.txt',
  '.webp',
  '.xls',
  '.xlsx',
  '.zip',
]

export const SupportedDocumentType = schemas.SupportedDocumentTypeEnum

export const extensionMap: Record<string, string> = {
  '.bmp': 'BMP',
  '.csv': 'CSV',
  '.doc': 'Word',
  '.docx': 'Word',
  '.gif': 'GIF',
  '.gz': 'GZ archive',
  '.heic': 'HEIC',
  '.heif': 'HEIF',
  '.ico': 'ICO',
  '.jpeg': 'JPEG',
  '.jpg': 'JPG',
  '.json': 'JSON',
  '.key': 'Keynote',
  '.log': 'log file',
  '.md': 'Markdown',
  '.numbers': 'Numbers',
  '.odt': 'OpenDocument text',
  '.ods': 'OpenDocument spreadsheet',
  '.pages': 'Pages',
  '.pdf': 'PDF',
  '.png': 'PNG',
  '.ppt': 'PowerPoint',
  '.pptx': 'PowerPoint',
  '.rtf': 'RTF',
  '.tar': 'TAR archive',
  '.tif': 'TIFF',
  '.tiff': 'TIFF',
  '.tsv': 'TSV',
  '.txt': 'text file',
  '.webp': 'WebP',
  '.xls': 'Excel',
  '.xlsx': 'Excel',
  '.zip': 'ZIP archive',
}

export const extensionAliasMap: Record<string, string[]> = {
  '.jpg': ['.jpeg', '.jpg'],
  '.jpeg': ['.jpeg', '.jpg'],
  '.tif': ['.tif', '.tiff'],
  '.tiff': ['.tif', '.tiff'],
  '.doc': ['.doc', '.docx'],
  '.docx': ['.doc', '.docx'],
  '.xls': ['.xls', '.xlsx'],
  '.xlsx': ['.xls', '.xlsx'],
  '.ppt': ['.ppt', '.pptx'],
  '.pptx': ['.ppt', '.pptx'],
}

export function getExtensionText(extension: string): string {
  if (extension in extensionAliasMap) {
    return extensionAliasMap[extension.toLowerCase()].join(' | ')
  }
  return extension
}

export function getFileDescription(allowedFileTypes: string[] | null): string {
  if (allowedFileTypes && allowedFileTypes.length > 0) {
    const displayNames = [
      ...new Set(
        allowedFileTypes.map(
          (ext) => extensionMap[ext.toLowerCase()] || ext.replace('.', '').toUpperCase(),
        ),
      ),
    ]
    const maxItems = 5

    const shouldTruncate = displayNames.length > maxItems
    const itemsToShow = shouldTruncate ? displayNames.slice(0, maxItems) : displayNames
    const remainingCount = displayNames.length - maxItems

    if (itemsToShow.length === 1 && !shouldTruncate) {
      return itemsToShow[0]
    } else if (itemsToShow.length === 2 && !shouldTruncate) {
      return `${itemsToShow[0]} or ${itemsToShow[1]}`
    } else {
      const lastItem = shouldTruncate
        ? `${remainingCount} other type${remainingCount === 1 ? '' : 's'}`
        : itemsToShow.pop()
      const conjunction = shouldTruncate ? 'and' : 'or'
      return `${itemsToShow.join(', ')}, ${conjunction} ${lastItem}`
    }
  }
  return 'JPEG, PNG, ZIP, or PDF'
}
